export default __webpack_public_path__ + "static/media/NoTimeline.9df86633.svg";